<template>
  <div class="teacher_page flex1 h100" style="padding: 50px 0 60px 0">
    <DashHeader
      v-if="session"
      :share="copyUrl"
      :openEvaluate="openEvaluate"
      :showStudents="showStudents"
      :reopenClass="_reopenClass"
      :turnModel="turnModel"
      :confirmModeChange="confirmModeChange" />
    <template v-if="!questionModalVisiable">
      <!--For video content classroom-->
      <div v-if="session?.video && !session.videoSlide" class="content" >
        <VideoPlayer v-if="Array.isArray(session.video)" :video="session.video[0]" :getResponeCount="getResponeCount" :responseContentList="responseContentList" />
        <VideoPlayer v-else :video="session.video" :getResponeCount="getResponeCount" :responseContentList="responseContentList" />
      </div>

      <!--else part for video-->
      <div v-else-if="getPage.type === 'video'" class="content" >
        <div v-if="!showVideoPlayer" class="popup-overlay">
          <div class="popup-box">
            <div v-if="$route.name === 't'">
              <h3>Please play this video using the Classroom Dashboard View</h3>
            </div>
            <div v-else>
              <h3>You are going to an interactive video environment</h3>
              <button class="watch-btn" @click="watchVideoClicked">
                Watch Video
              </button>
            </div>
          </div>
        </div>
        <VideoPlayer
          v-if="showVideoPlayer && videoData"
          :getPage="getPage"
          :video="videoData"
          :getResponeCount="getResponeCount"
          :responseContentList="responseContentList"
          @closeVideoPlayer="closeVideoPlayer"
          :isPpt="true"
        />
        <div v-if="!showVideoPlayer">
          <DashboardPage
            v-if="isDashboard"
            :currentAnswerCount="currentAnswerCount"
            :responseContentList="responseContentList"
            :responsePercentage="responsePercentage"
            :meterialVisiable="isMaterialShow"
            :overviewModalVisiable="overviewModalVisiable"
            :changePage="pageChange"
            :session="session" 
            :getResponeCount="getResponeCount" 
            />
        </div>
      </div>
      <div v-else class="content">
        <TeacherPPTPage
          v-if="!isDashboard"
          :currentAnswerCount="currentAnswerCount"
          :responseContentList="responseContentList"
          :meterialVisiable="isMaterialShow" />
        <DashboardPage
          v-if="isDashboard"
          :currentAnswerCount="currentAnswerCount"
          :responseContentList="responseContentList"
          :responsePercentage="responsePercentage"
          :meterialVisiable="isMaterialShow"
          :overviewModalVisiable="overviewModalVisiable"
          :changePage="pageChange"
          :session="session" 
          :getResponeCount="getResponeCount" />
      </div>
      <div class="control">
        <!--
          isVideoClassroom prop is added to manipulate the options
        -->
        <teacherControlPanel
          v-if="session"
          :isVideoClassroom="session?.video && !session.videoSlide ? true : false"
          :currentPage="parseInt(currentPageIndex) + 1"
          :isDashboard="isDashboard"
          :changePage="pageChange"
          :turnModel="turnModel"
          :current_response="currentAnswerCount"
          :isClosed="session.status == 'close'"
          :reopenClass="_reopenClass"
          :meterialVisiable="isMaterialShow"
          :showDashTips="showDashTips"
          :showNewPrompt="showNewPrompt"
          :dashTipsModalVisiable="dashTipsModalVisiable"
          :getPage="getPage" />
      </div>
    </template>

    <guidePrompt v-if="isInitOk" :isDashboard="isDashboard" :guideOkCall="guideOkCall" />

    <CommentModal />

    <el-dialog title="Set feedback failure" :visible.sync="showTimeSetDialog">
      <feedbackTimePanel :mode="mode" :changeFeedbackTimeMode="changeFeedbackTimeMode" />
    </el-dialog>

    <el-dialog title="" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="cancelled" :append-to-body="true">
      <div class="dialog_page">
        <div>This session has been cancelled, please schedule another workshop</div>
        <div class="flex_r pd_t1">
          <el-button type="danger" @click="backToClass()">Confirm</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="isInitOk && isGuideOk && (session.welcome || showShareEvenClose)"
      title="Join at classcipe.com"
      @close="closeCopyDialog"
      :visible="session.welcome || showShareEvenClose"
      :center="true"
      custom-class="custom-dialog"
      top="2vh"
      width="90vw">
      <AnonymousLogin :closeLoginModal="closeCopyDialog" />
    </el-dialog>

    <el-dialog
      title="Reopen session"
      @close="closeReopenDialog"
      v-if="showReopenDialog"
      :visible="showReopenDialog"
      :center="true"
      custom-class="custom-dialog"
      top="2vh"
      width="700px">
      <ReopenDialog :close="closeReopenDialog" />
    </el-dialog>

    <el-dialog :visible.sync="isZoomSettingDialogShow">
      <div class="zoom-setting-dialog">
        <div class="title-wrapper">
          <img src="../assets/meetings.png" style="height: 1.2rem" />
          <img src="../assets/ZoomLogo.png" style="height: 0.8rem; padding-left: 0.2rem" />
          <div class="text">Zoom meeting setting</div>
        </div>
        <div class="body-wrapper">
          <!-- <div class="title">Link your Zoom account to Classcipe to schedule a Zoom meeting for this class</div> -->
          <div class="title-teal">The link to this meeting will be generated automatically and assigned to the participants</div>
          <div class="waiting-room">
            <div class="switch-label">Waiting room</div>
            <el-switch v-model="waitingRoom" inactive-color="#999" />
          </div>
        </div>

        <div class="button-wrapper">
          <!-- <el-button rounded flat no-caps label="Not now" class="text-grey-7" style="border: 1px solid" @click="isZoomSettingDialogShow = false" /> -->
          <el-button class="confirm-button" @click="createZoom">Confirm</el-button>
        </div>
      </div>
    </el-dialog>

    <el-drawer :with-header="false" :visible.sync="showClassroomRoster" direction="ltr" size="90%">
      <!--
      <classroom-roster :openEvaluate="openEvaluate" v-show="showClassroomRoster" v-if="isGuideOk" @close="showClassroomRoster = false" />
      -->
      <classroom-roster :openEvaluate="openEvaluate" v-show="showClassroomRoster" @close="showClassroomRoster = false" />
    </el-drawer>

    <!--
    <studentAudioItem class="flex1" v-else-if="getQuestion.type === 'media'" v-bind="$attrs" :addMediaAnswer="addMediaAnswer" />
    <el-dialog :visible.sync="showNewPromptDialog" fullscreen>
      <new-prompt-page style="height: 900px" :addPPTItem="addPPTItem" :closeBtn="closeNewPrompt" />
    </el-dialog>
    -->
    <new-prompt-page
      v-if="showNewPromptDialog"
      class="flex1"
      :currentPage="parseInt(currentPageIndex) + 1"
      :addPPTItem="addPPTItem"
      :closeBtn="closeNewPrompt" />
    <el-dialog :visible.sync="showStudentPacedNotePage" :show-close="false" :close-on-click-modal="false" width="80%">
      <ModalStudentModeOn v-if="showStudentPacedNotePage" :confirmModeChange="confirmModeChange" :cancelModeChange="cancelModeChange" />
    </el-dialog>

    <el-drawer direction="ltr" :visible.sync="dashTipsModalVisiable" size="90%" :withHeader="false">
      <!-- <el-dialog :visible.sync="dashTipsModalVisiable" width="80%"> -->
      <dashTipsModal :close="showDashTips" :isTeacher="true" />
      <!-- </el-dialog> -->
    </el-drawer>

    <bigPreview :isShowResponse="showResponse" />
    <preview-metarial-item :meterialVisiable="isMaterialShow" />

    <el-drawer :destroy-on-close="true" size="95%" :visible.sync="drawerEvaluate" direction="ltr" :withHeader="false" :wrapperClosable="false">
      <el-button icon="el-icon-close" style="position: absolute; top: 1rem; right: -1.5rem; z-index: 1000" circle @click="closeEvaluate"></el-button>
      <iframe class="flex1" style="margin: 0" :src="evaluationUrl" frameborder="0"></iframe>
    </el-drawer>
    <DrawBox v-if="($route.name === 'd' && !syncUI.fullPlayOn) || $route.name === 't'" />
    <fullPlay v-if="($route.name === 'd' && !syncUI.fullPlayOn) || $route.name === 't'" />
    <remotePlay v-if="$route.name === 'd' && syncUI.fullPlayOn === 'projector'" />
    <fullIframe />
    <fullDoc />
    <!-- <drawTop v-if="isGuideOk && syncUI.drawUrl" /> -->
  </div>
</template>

<script>
import copy from 'copy-to-clipboard'
// import drawTop from '@/components/drawTop.vue'
import {getStore} from '@/utils/localStore'
import {showLoading, hideLoading, showToast} from '../utils/loading'
import fullPlay from '@/components/fullPlay.vue'
import DrawBox from '@/components/DrawBox.vue'
import fullIframe from '@/components/fullIframe.vue'
import fullDoc from '@/components/fullDoc.vue'
import remotePlay from '@/components/common/remotePlay.vue'
import teacherControlPanel from '../components/teacher/teacherControlPanel'
import CommentModal from '@/components/teacher/commentModal.vue'
import TeacherPPTPage from '@/components/teacher/teacherPPTPage.vue'
import DashboardPage from '@/components/teacher/dashboardPage.vue'
import feedbackTimePanel from '../components/teacher/feedbackTimePanel'
import AnonymousLogin from '../components/teacher/AnonymousLogin.vue'
import ReopenDialog from '../components/teacher/ReopenDialog.vue'
import dashCopyDialog from '../components/teacher/dashCopyDialog'
import StudentsQsModal from '@/components/teacher/studentsQsModal.vue'
import guidePrompt from '@/components/guidePrompt.vue'
import DashHeader from '@/components/teacher/dashHeader.vue'
import dashTipsModal from '@/components/teacher/dashTipsModalV3.vue'
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import NewPromptPage from '@/components/teacher/newPromptPage.vue'
import bigPreview from '@/components/common/bigPreview.vue'
import ClassroomRoster from '@/components/teacher/ClassroomRoster'
import PreviewMetarialItem from '@/components/drag/previewMetarialItem.vue'
import VideoPlayer from '@/components/teacher/interactive-video/VideoPlayer.vue'

import ModalStudentModeOn from '@/components/teacher/modals/StudentModeOn.vue'

export default {
  components: {
    guidePrompt,
    ClassroomRoster,
    teacherControlPanel,
    CommentModal,
    TeacherPPTPage,
    DashboardPage,
    // welcomeModal,
    feedbackTimePanel,
    AnonymousLogin,
    ReopenDialog,
    StudentsQsModal,
    DashHeader,
    dashCopyDialog,
    dashTipsModal,
    NewPromptPage,
    bigPreview,
    PreviewMetarialItem,
    DrawBox,
    fullPlay,
    remotePlay,
    fullIframe,
    fullDoc,
    // drawTop,
    ModalStudentModeOn,
    VideoPlayer,
  },
  data() {
    return {
      isInitOk: false,
      rosterLoading: false,
      studentCounts: 0,
      currentSo: null,
      currentAnswerCount: 0,
      cancelled: false,
      name: '',
      googleLoginStatus: 0, // 0 未知， -1 登录， 1 登录
      responseContentList: [],
      token: '',
      isLocked: false,
      isDashboard: false,
      responsePercentage: [],
      isFocus: [],
      welcomeModalVis: false,
      welcomeModalShowed: false,
      showTimeSetDialog: false,
      copyLinkBtnString: '',
      firstCloseCopyLinkDialog: true,
      mode: 1,
      questionModalVisiable: false,
      markupslist: [], // ppt comment列表
      overviewModalVisiable: false,
      dashTipsModalVisiable: false,
      showNewPromptDialog: false,
      showReopenDialog: false,
      inputDialog: false,
      sendControlDelay: null,
      showClassroomRoster: false,
      showNetErrorDelay: null,
      drawerEvaluate: false,
      evaluationUrl: '',
      showShareEvenClose: false,

      // turn mode modal
      showStudentPacedNotePage: false,
      isGuideOk: false,

      // zoom setting
      isZoomSettingDialogShow: false,
      waitingRoom: false,
      showVideoPlayer: false,
      videoData: null,
    }
  },
  created() {
    window._this = this
    window._state = this.$store.state
    window._store = this.$store
    this.$store.commit('setClassId', {id: this.$route.params.id, name: this.$route.name})
  },
  async mounted() {
    localStorage.setItem('referrer', document.referrer)
    window._st = Date.now()
    window.classId = this.class_id
    this.isDashboard = this.$route.name === 'd'
    this.token = this.$route.query.token || (await App.authentication.getAccessToken()) || ''
    await this.$store.dispatch('getClassInfo')
    App.service('session').removeAllListeners(['patched', 'removed'])
    App.service('session')
      .on('patched', (rs) => {
        commit('patchSession', rs)
      })
      .on('removed', (rs) => {
        if (rs.sid === this.session.sid) {
          this.cancelled = true
        }
      })
    const {commit} = this.$store
    App.service('response').removeAllListeners(['created', 'patched', 'removed'])
    App.service('response')
      .on('created', (rs) => {
        commit('student/setAllAnswerdListOne', rs)
      })
      .on('patched', (rs) => {
        commit('student/setAllAnswerdListOne', rs)
      })
      .on('removed', (rs) => {
        commit('student/deleteOnAnswerById', rs._id)
      })
    App.service('auth').removeAllListeners(['patched'])
    App.service('auth').on('patched', (rs) => {
      const {id, on, from, user, role} = rs
      if (id === 'syncUI') return commit('setSyncUI', rs, {root: true})
      if (user) {
        const online = on === 'connect' ? true : false
        if (role === 'teacher') return commit('teacher/setTeacher', user), commit('teacher/setOnlineTeacher', [[user._id], online])
        commit('teacher/setOnlineList', [[user._id], online])
        return
      }
      if (this.$route.name === 'p' && this.isStudentPaced) return
      try {
        if (rs.emit) EventBus.$emit(rs.emit, rs.data)
        if (rs.method && this[rs.method]) this[rs.method](rs.data)
        if (rs.commit) commit(rs.commit, rs.data)
      } catch (error) {}
    })
    if (!this.session?._id) {
      this.cancelled = true
      hideLoading()
      return
    }
    await this.initWithToken()
    await this.$store.dispatch('getClassInfo')
    if (this.$route.query.reopen) this._reopenClass() // 重开课堂通知
    window.teachers = this.teachers
    window.groups = this.groups
    if (!this.session.drawkey) {
      let drawkey = await Fn.drawKey()
      await this.$store.dispatch('upSession', {drawkey})
    }
    await this.$store.dispatch('getClassDetail')
    await this.$store.dispatch('getTakeaway')
    this.checkZoom()
  },
  computed: {
    ...mapState(['session', 'class_id', 'syncUI']),
    ...mapState('student', ['currentPageIndex']),
    ...mapState('teacher', ['students', 'teachers', 'groups']),
    ...mapGetters(['getPage', 'getPageId', 'getPageNum', 'getQuestion', 'isMaterialShow', 'isStudentPaced', 'isMentorOrSubstitute']),
    showResponse() {
      return this.$store.getters['teacher/isResponseShow'](this.currentPageIndex)
    },
  },
  watch: {
    currentPageIndex() {
      this.getPageData()
      if (!this.isInitOk) return 0
    },
  },
  beforeRouteEnter(to, from, next) {
    window.isTeacherPage = true
    next((vm) => {})
  },
  methods: {
    ...mapMutations('teacher', ['hidePageMaterial']),
    ...mapActions('teacher', ['initStudent', 'setFeedBackList', 'setFeedBackAnswerIds']),
    ...mapActions('student', ['setStudentPageIndex', 'setAllAnswerdList']),
    closeNewPrompt() {
      this.showNewPromptDialog = false
    },
    showNewPrompt() {
      this.showNewPromptDialog = true
    },
    addPPTItem(item) {
      if(item?.video){
        location.reload()
      }else{
        this.$store.commit('patchSession', item)
        this.pageChange(parseInt(this.currentPageIndex) + 2)
        this.$store.dispatch('initMaterials')
        hideLoading()
      }
    },
    showInputDialog() {
      this.inputDialog = true
    },
    showDashTips() {
      this.dashTipsModalVisiable = !this.dashTipsModalVisiable
    },
    closeEvaluate() {
      this.drawerEvaluate = false
    },
    openEvaluate() {
      if (this.evaluationUrl) this.drawerEvaluate = true
    },
    // 检查token
    async initWithToken() {
      showLoading()
      if (!this.token) return this.goToLogin()
      const {logout, authentication, user} = await App.authenticate(
        {strategy: 'jwt', accessToken: this.token},
        {query: {sid: this.class_id, role: 'teacher'}}
      ).catch((err) => {
        return {logout: true}
      })
      if (logout) return this.goToLogin()
      if (authentication) {
        Acan.url('token', null)
        if (Acan.url('status') === 'student' && this.session.status !== 'student') {
          await this.$store.dispatch('upSession', {status: 'student'})
          Acan.url('status', null)
        }
      }
      this.name = window.currentNickname = user?.nickname
      window.uid = user?.email
      window.currentUserId = user?._id
      window.Auser = user
      window.class_id = this.class_id
      await Promise.all([this.initStudent(user), this.getAllSlides()])
      await this.$store.dispatch('initPageConf')
      setTimeout(() => {
        this.isInitOk = true
        if (this.$route.query.roster) {
          this.showStudents()
        }
        hideLoading()
      }, 100)
    },
    async guideOkCall() {
      this.isGuideOk = true
    },
    async guideCall() {
      if (this.isGuideOk) return
      await sleep(100)
      return this.guideCall()
    },
    goToLogin() {
      const url = `${hostUrl}/v2/login?from=roomTeacher&role=teacher&back=` + encodeURIComponent(location.origin + location.pathname)
      location.href = url
    },
    pageChange(value, notSend) {
      this.giveFocus(parseInt(value) - 1, notSend)
      if(this.showVideoPlayer){
        this.closeVideoPlayer()
      }
      return
    },
    getPageData() {
      this.questionModalVisiable = false //与控制面板中的comment显示与否的按钮保持同步
      this.getItemData()
    },
    // 老师控制分页
    async sendPageControl() {
      App.service('auth').patch('syncTeacher', {commit: 'student/setCurrentPageIndex', data: this.currentPageIndex})
    },
    async getAllSlides() {
      // 初始化评论数据
      await Promise.all([
        App.service('comments')
          .find({query: {sid: this.class_id, $limit: 1000}})
          .then((rs) => {
            if (rs) this.setFeedBackList(rs.data)
            this.setFeedBackAnswerIds(rs.data.map((v) => v.rid))
          }),
        App.service('response')
          .find({query: {sid: this.class_id, $limit: 2000}})
          .then((rs) => {
            this.setAllAnswerdList(rs.data)
          }),
        this.$store.dispatch('initMaterials'),
      ])
      this.getItemData()
      this.session.pages?.map((o, i) => {
        this.responsePercentage[i] = 0
      })
      this.isFocus[this.currentPageIndex] = true
    },
    getItemData() {
      this.$nextTick(() => {
        if (!this.getQuestion) return
        this.getResponeCount()
      })
    },
    getCurrentVideoQuizAnswer() {
      let list = this.$store.state.student.allAnswerList.filter((item) => item.quizId === this.$store.state.student.currentVideoQuizId)
      return list
    },
    getCurrentPageAnswer() {
      const {type, page} = this.getQuestion
      let list = this.$store.state.student.allAnswerList.filter((item) => item.page === page)
      return list
      /*
      if (type !== 'comment') {
      } else {
        // comment remark 特殊，数据不在answer内
        let list = this.$store.state.remark.allRemarks.filter((item) => item.page_id === page_id)
        return list
      }*/
    },
    getResponeCount(f) {

      if (f || this.getQuestion) {

        const list = this.session?.video ? this.getCurrentVideoQuizAnswer() : this.getCurrentPageAnswer()

        this.currentAnswerCount = list.length
        this.responseContentList = list
        let count = 0
        let id = '-1'
        for (let i = 0; i < list.length; i++) {
          if (id != list[i].user_id) {
            count++
            id = list[i].user_id
          }
        }

        if (this.studentCounts < count) {
          this.studentCounts = count
        }
        if (count == 0) {
          this.responsePercentage[this.currentPageIndex] = 0
        } else {
          this.responsePercentage[this.currentPageIndex] = (count * 100) / this.studentCounts
        }
      } else {
        this.currentAnswerCount = 0
      }
    },
    copyUrl() {
      if (this.session.status === 'close') {
        this.showShareEvenClose = true
        if (!this.isMentorOrSubstitute) {
          this.$message.info({message: 'Please reopen session first', customClass: 'z-max'})
        }
      } else {
        this.$store.dispatch('upSession', {welcome: true})
      }
    },
    closeReopenDialog() {
      this.showReopenDialog = false
    },
    closeCopyDialog() {
      if (this.session.status === 'close' && this.showShareEvenClose) {
        this.showShareEvenClose = false
        return
      }
      if (this.session.welcome) this.$store.dispatch('upSession', {welcome: false})
      this.showWelcome()
    },
    showWelcome() {
      const welcomesetting = getStore('welcomesetting')
      if (!this.welcomeModalShowed && !this.isDashboard && !welcomesetting) {
        this.welcomeModalShowed = true
        this.welcomeModalVis = true
      }
    },
    hideWelcome() {
      this.welcomeModalVis = false
    },
    getBtnString() {
      if (this.$store.getters['teacher/onlineStudentCount'] == 0) {
        this.copyLinkBtnString = 'Waiting for students..'
      } else if (this.currentPageIndex == 0) {
        this.copyLinkBtnString = 'Start Class'
      } else {
        this.copyLinkBtnString = 'Continue'
      }
      return this.copyLinkBtnString
    },
    async turnModel() {
      if (this.session.status === 'student') {
        await this.$store.dispatch('upSession', {status: 'live'})
        this.sendModeChangeCommend()
      } else {
        this.showStudentPacedNotePage = true
      }
    },
    async confirmModeChange() {
      await this.$store.dispatch('upSession', {status: 'student'})
      this.sendModeChangeCommend()
      this.showStudentPacedNotePage = false
    },
    cancelModeChange() {
      this.showStudentPacedNotePage = false
    },
    sendModeChangeCommend() {
      if (this.session.status !== 'live') return
      // 如果从学生模式切换到老师模式，则通知学生进行页面切换操作
      this.sendPageControl()
      if (this.isMaterialShow) {
        //this.$route.name === 'd'
        this.$store.dispatch('syncTeacher', {commit: 'teacher/showPageMaterial', data: [this.currentPageIndex, this.getPageId]})
        this.$store.dispatch('syncTeacher', {commit: 'setMaterialSelect', to: 'teacher', data: this.$store.state.materialSelect})
      }
    },
    open() {
      var strWindowFeatures = 'width=1200,height=750,menubar=yes,resizable=yes,scrollbars=true,status=true,top=100,left=200'
      window.open(`/d/${this.class_id}?p=${this.currentPageIndex}`, '_blank', strWindowFeatures)
    },
    //重新开启课堂
    async _reopenClass() {
      //this.showReopenDialog = true
      await this.$store.dispatch('upSession', {status: 'live'})
      this.$message.info({message: 'Session reopened', customClass: 'z-max'})
    },
    //显示当前的学生
    async showStudents(tab) {
      showLoading()
      await this.$store.dispatch('getClassInfo')
      localStorage.setItem('RoomRoster:Tab', tab || 'student')
      hideLoading()
      this.showClassroomRoster = true
    },
    closeStudents() {
      this.showClassroomRoster = false
    },
    giveFocus(index, notSend) {
      if (isNaN(index)) return false
      if (this.currentPageIndex === index) return false
      if (index != this.currentPageIndex) {
        this.setStudentPageIndex(index)
        this.getResponeCount()
      }
      if (!notSend && this.session.status !== 'student') this.sendPageControl()
      for (let i = 0; i < this.getPageNum; i++) {
        this.isFocus[i] = i == index
      }
    },
    changeFeedbackTimeMode(index) {
      this.mode = index
    },
    backToClass() {
      location.href = hostUrl
    },
    checkZoom() {
      if (this.isDashboard && !this.session?.zoom?.id) {
        this.isZoomSettingDialogShow = true
      }
    },
    async createZoom() {
      const zoom = {
        checked: true,
        passcode: false,
        capacity: 100,
        invalid: false,
        waiting_room: this.waitingRoom,
        zoomChecked: true,
        defaultOpenZOOM: true,
      }
      const dto = {
        _id: this.session._id,
        sid: this.session.sid,
        name: this.session.name,
        zoom,
      }
      const res = await App.service('session').patch('createZoom', dto)
      this.isZoomSettingDialogShow = false
    },
    async watchVideoClicked() {
      this.showVideoPlayer = true
      this.videoData = this.session.video[this.getPage._id]
      await App.service('auth').patch('syncTeacher', {commit: 'student/setWatchVideoClicked', data: true})
      await this.$store.dispatch('student/setWatchVideoClicked', true)
    },
    async closeVideoPlayer() {
      this.showVideoPlayer = false
      this.videoData = null
      await App.service('auth').patch('syncTeacher', {commit: 'student/setWatchVideoClicked', data: false})
      await this.$store.dispatch('student/setWatchVideoClicked', false)
    }
  },
}
</script>

<style lang="scss">
@import url(../assets/css/teacher.scss);
.popup-overlay {
  position: fixed;
  top: 50%;
  left: 50%;
  right: 0;
  bottom: 0;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  transform: translate(-50%, -50%);
}

.popup-box {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.watch-btn {
  background-color: #26a69a;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 1rem;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.watch-btn::before {
  content: "✔";
  font-size: 1rem;
  color: #fff;
}
</style>
